import { render, staticRenderFns } from "./QurbanTrackingResult.vue?vue&type=template&id=479aca7a"
import script from "./QurbanTrackingResult.vue?vue&type=script&lang=js"
export * from "./QurbanTrackingResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports